import { useEffect, useRef } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useAuth } from '@/components/providers/auth-provider'

export function GitHubCallback() {
    const [searchParams] = useSearchParams()
    const navigate = useNavigate()
    const { loginWithGitHub } = useAuth()
    const hasRun = useRef(false)

    useEffect(() => {
        if (hasRun.current) return
        hasRun.current = true
        const code = searchParams.get('code')
        const error = searchParams.get('error')

        if (error) {
            navigate('/auth/login', {
                state: { error: 'GitHub authentication failed' }
            })
            return
        }

        if (code) {
            loginWithGitHub(code)
                .then(() => {
                    navigate('/app/dashboard')  // ADD THIS
                })
                .catch(() => {
                    navigate('/auth/login', {
                        state: { error: 'Authentication failed' }
                    })
                })
        }
    }, [])

    return (
        <div className="flex items-center justify-center min-h-screen">
            <div className="text-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900 mx-auto" />
                <p className="mt-4 text-gray-600">Completing GitHub sign-in...</p>
            </div>
        </div>
    )
}